<template>
  <div class="mt-8 flex flex-col items-center">
    <slot>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        stroke="currentColor"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        class="h-24 w-24 text-red-700"
      >
        <!-- eslint-disable-next-line max-len -->
        <path  d="M4.012 10.978a5 5 0 00.62 6.712c.922.84 1.868.994 3.371 1.304 2.497.506 6.265.352 8 0M8.81 6.152a5.002 5.002 0 018.11 2.926 5.002 5.002 0 014.046 5.375m0 4.541L4.012 6.152"/>
      </svg>
      <div class="mt-4">
        <h2 class="font-bold">Oops!, your connection seems off...</h2>
        <p class="text-gray-600">Keep calm, try again and click retry.</p>
      </div>
      <m-button
        @click="$emit('retry')"
        class="mt-8"
      >Retry</m-button>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'MNetworkError',
};
</script>
